'use client';

import Footer from 'components/Footer';
import Navbar from 'components/Navbar';
import { usePathname } from 'next/navigation';
import { FC, PropsWithChildren, useCallback, useEffect, useState } from 'react';

const LayoutMain: FC<PropsWithChildren<unknown>> = ({ children, ...rest }) => {
  const pathname = usePathname();
  const [small, setSmall] = useState(pathname.includes('sign-up'));

  const handleSmall = useCallback(() => {
    if (window.pageYOffset > 71) setSmall(true);

    if (window.pageYOffset === 0 && !pathname.includes('sign-up')) setSmall(false);
  }, [pathname]);

  useEffect(() => {
    if (typeof window !== 'undefined') window.addEventListener('scroll', handleSmall);
  }, [handleSmall]);

  useEffect(() => {
    setSmall(pathname.includes('sign-up'));
  }, [pathname]);

  return (
    <>
      <Navbar small={small} />
      <div className="snap-y snap-mandatory">{children}</div>
      <Footer />
    </>
  );
};

export default LayoutMain;
